import btoa from "btoa";
import {EDITOR_MODE_HTML, EDITOR_MODE_MARKDOWN, EDITOR_MODE_RICH} from "../constants/EditorMode";
import MarkdownHelper from "./MarkdownHelper";
import {DRAFT, PROTECT, MigrateVisibilityValues} from "../constants/visibility";

const AttachmentPattern = new RegExp(/\[##_(Image|ImageGrid|ImageSlide|File)\|([^|]+)\|.*?_##\]/g);
export function getAttachmentKeysFromContent(content) {
  let attachments = [];
  const matched = content.match(AttachmentPattern);
  if (matched) {
    matched.map(item => {
      attachments = attachments.concat(item.split('|')[1].split(','))
    });
  }
  return attachments;
}

const ImageAttachmentPattern = new RegExp(/\[##_(Image|ImageGrid|ImageSlide)\|([^|]+)\|.*?_##\]/g);
export function getThumbnailFromContent(content) {
  const images = content.match(ImageAttachmentPattern);
  if (images && images.length > 0) {
    return images[0].split('|')[1].split(',')[0];
  } else {
    return null;
  }
}

export function generatePassword() {
  return btoa(Math.random()).substring(0, 8);
}

export function titleToSlogan(title) {
  return title.replace(/(\s+)/g, '-');
}

export function setEditorContent($editorMode, $content) {
  const activeEditor = window.activeEditor;
  if ($editorMode === EDITOR_MODE_RICH) {
    activeEditor.setContent($content);
  } else if ($editorMode === EDITOR_MODE_HTML) {
    activeEditor.setValue($content);
  } else if ($editorMode === EDITOR_MODE_MARKDOWN) {
    activeEditor.setValue(MarkdownHelper.htmlToMarkdown($content));
  }
}

export function getEditorContent($editorMode) {
  const activeEditor = window.activeEditor;
  if ($editorMode === EDITOR_MODE_RICH) {
    return activeEditor._getkContent();
  } else if ($editorMode === EDITOR_MODE_HTML) {
    return activeEditor.getValue();
  } else if ($editorMode === EDITOR_MODE_MARKDOWN) {
    return MarkdownHelper.markdownToHtml(activeEditor.getValue());
  }
}

export const publishButtonMessage = (publishing, visibility) => {
  if (publishing) {
    return '저장 중';
  }

  switch(visibility) {
    case DRAFT:
      return '비공개 저장';
    case PROTECT:
      return '공개(보호) 발행';
    default:
      return '공개 발행';
  }
}

export const adjustVisibility = (visibility, categoryVisibility) => {
  if (categoryVisibility === DRAFT) {
    return DRAFT
  }

  const found = MigrateVisibilityValues.find(item => item.value === Math.abs(visibility))
  const migrateValue = found ? found.migrateValue : DRAFT;

  // 최초 전달된 글의 Visibility가 음수(예약)일 경우 mig한 visibility를 음수로 변경해 돌려보낸다.
  return (visibility < 0) ? Math.abs(migrateValue) * -1 : migrateValue;

}

export const getCategoryDisplayName = (category) => {
  let name = category.name
  if (category.visibility == 0 ) {
    name += ' (비공개)'
  }
  return name
}


/**
 * nested 구조를 Flat 일차원 배열로 만들어 Visibility를 조회할수 있도록 함.
 * @param post object
 * @param categories array
 * @returns {number} 20 | 0
 */
export function selectPostCategoryVisibility(post, categories) {

  const pattern = ((accumulator, current) => {

    accumulator.push({id: current.id, visibility: current.visibility});                       // push value

    if (current.children) return accumulator.concat(current.children.reduce(pattern, []));    // push child values

    return accumulator;
  });

  const category = categories.reduce(pattern, []).find(item => item.id == post.category);

  return category ? category.visibility : 20
}

/**
 * 공개, 보호, 친구공개, 비공개중 어떤 상태의 글을 발행할수 있는지 확인한다.
 * @param blogVisibility
 * @param categoryVisibility
 * @param itemVisibility
 * @returns {boolean}
 */
export function canUseVisibility(blogVisibility, categoryVisibility, itemVisibility) {
  return itemVisibility <= Math.min(blogVisibility, categoryVisibility)
}
